import React from 'react';

export const useStateWithActions = (actions, reducer, initialState, initFunc) => {
    const [state, dispatch] = React.useReducer(reducer, initialState, initFunc);
    const actionCallbacks = Object.keys(actions).reduce(
        (acc, key) => ({
            ...acc,
            ...(typeof actions[key] === 'function' && { [key]: actions[key](dispatch, state) }),
        }),
        {},
    );

    return [actionCallbacks, state];
};
